import { AbstractControl, FormGroup } from '@angular/forms';

import { Observable, map, startWith } from 'rxjs';

import { PasswordRequirement } from '../models/password-requirement';

export function getPasswordRequirements$(formGroup: FormGroup): Observable<PasswordRequirement[]> {
  return formGroup.valueChanges.pipe(
    startWith({ password: '' }),
    map(() => {
      const password: AbstractControl = formGroup.get('password');
      const isEmpty = !password.value;

      return [
        {
          message: 'PASSWORD.REQUIREMENTS.AT_LEAST_8_CHARACTERS',
          hasError: password.hasError('minlength') || isEmpty,
        },
        {
          message: 'PASSWORD.REQUIREMENTS.NO_SPACES',
          hasError: password.hasError('pattern'),
        },
      ];
    }),
  );
}

export function getPasswordErrorMessage$(
  requirements$: Observable<PasswordRequirement[]>,
): Observable<string> {
  return requirements$.pipe(
    map(
      requirements =>
        'PASSWORD.REQUIREMENTS.' + (requirements[0].hasError ? 'LENGTH_ERROR' : 'SPACE_ERROR'),
    ),
  );
}
